<template>
<div>

<DialogBox :settings="settings" @show="initialiseDialog">
    <div class="pa-3">
        <v-select v-model="program" :items="programItems" />
        <v-text-field v-if="program=='tc'" v-model="contactKey" label="Contact Key" />
        <v-text-field v-if="program=='tot'" v-model="templateKey" label="Template Key" />
        <UserChooser v-if="this.program == 'tcu' || this.program == 'ttu'" v-model="user" label="User" />
        <v-select v-model="sourceTenant" :items="tenants" item-text="name" item-value="meta.key" label="Source Tenant" />
        <v-select v-model="destinationTenant" :items="tenants.filter(o => o.meta.key != sourceTenant)" item-text="name" item-value="meta.key" label="Destination Tenant" />
        <div style="display:flex">
            <v-switch v-model="move" color="primary" label="Remove from Source" />
            <v-checkbox v-model="simulateWrites" color="primary" label="Simulate Writes" />
            <v-checkbox v-model="simulateDeletes" color="primary" label="Simulate Deletes" />
        </div>
        <v-btn @click="run">Go</v-btn>
        <v-textarea v-model="output" label="Results" />
    </div>
</DialogBox>


</div>
</template>

<script>
 
import DialogBox from '../ui-elements/DialogBox'
import UserChooser from '../ui-elements/UserChooser'
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers';
import FirebaseHelpers from '../helpers/FirebaseHelpers';
import Utilities from '../helpers/Utilities';
import NiceData from '../data/NiceData'

export default {
    data() {
        return {
            program: null,
            contactKey: null,
            templateKey: null,
            output: '',
            user: null,
            sourceTenant: null,
            destinationTenant: null,
            simulateWrites: true,
            simulateDeletes: true,
            move: false,
        }
    },
    components: {
        DialogBox,
        UserChooser,
    },

    props: {
        initialProgram: null,
        item: Object,
        settings: Object
    },

    computed: {
        programItems() {
            return [
                {text: "Transfer Contact", value: 'tc'},
                {text: "Transfer Contacts for User", value: 'tcu'},
                {text: "Transfer All Contacts", value: 'tac'},
                {text: "Transfer Tasks for User", value: 'ttu'},
                {text: "Transfer All Templates", value: 'tat'},
                {text: "Transfer One Template", value: 'tot'},
                {text: "Transfer Lookups", value: 'tl'},
                {text: "Transfer All Groups", value: 'tag'},
            ]
        },
        tenants() {
            return this.$store.getters.officesActive
        },
        sourceTenantRef() {
            return DataHelpers.getRootRef().child('tenants').child(this.sourceTenant)
        },

        destinationTenantRef() {
            return DataHelpers.getRootRef().child('tenants').child(this.destinationTenant)
        }        


    },


    methods: {
        initialiseDialog() {
            this.settings.closeOnly = true
            this.program = this.initialProgram
            this.contactKey = NiceData.safelyGetKey(this.item)
            this.sourceTenant = this.$store.getters.tenantKey
            this.output = ''
        },
        log(msg) {
            this.output += msg + '\n'
        },
        run() {
            this.output = ''
            if(this.program == 'tc')
                this.transferContact()
            if(this.program == 'tat')
                this.transferAllTemplates()
            if(this.program == 'tcu')
                this.transferContactsForUser()
            if(this.program == 'tac')
                this.transferAllContacts()
            if(this.program == 'ttu')
                this.transferTasksForUser()
            if(this.program == 'tl')
                this.transferLookups()
            if(this.program == 'tag')
                this.transferAllGroups()
            if(this.program == 'tot')
                this.transferOneTemplate()

        },

        transferContact() {
            let newTenant = this.destinationTenant
            this.log(`Moving to tenant ${newTenant} ...`)
            this.copyContactToTenant(this.contactKey, newTenant)
            if(this.item.partner)
                this.copyContactToTenant(this.item.partner.key, newTenant)
        },

        transferOneTemplate() {
            let sourceTemplateRef = this.sourceTenantRef.child('templates').child(this.templateKey)
            let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant.toString()).child('templates')
            
            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                this.log('Transferred template')
            })
        },        

        transferAllTemplates() {
                let sourceTemplateRef = this.sourceTenantRef.child('templates')
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant.toString())
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred ' + Object.keys(result.object).length.toString() + ' templates ')
                })

                sourceTemplateRef = this.sourceTenantRef.child('transactionTemplates')
                destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant.toString())
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result2 => {
                    
                    this.log('Transferred ' + Object.keys(result2.object).length.toString() + ' Transaction templates ')
                })
            
        },

        transferLookups() {
                let sourceTemplateRef = this.sourceTenantRef.child('lookup')
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant.toString())
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred ' + Object.keys(result.object).length.toString() + ' lookup items')
                })
        },

        transferAllGroups() {
                let sourceTemplateRef = this.sourceTenantRef.child('groups')
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant.toString())
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred ' + Object.keys(result.object).length.toString() + ' groups')
                })
        },

        transferContactsForUser() {
            let listContactsRef = this.sourceTenantRef.child('contacts').orderByChild('owner/key').equalTo(this.user.key)
            console.log('ref is ' + listContactsRef.toString())
            listContactsRef.once('value', snap => {
                snap.forEach(itemSnap => {
                    let contactKey = itemSnap.key
                    let contact = itemSnap.val()
                    this.log('Transferring contact: ' + ContactHelpers.fullName(contact) + ' - ' + contactKey)
                    this.copyContactToTenant(contactKey, this.destinationTenant)
                })
            })
        },

        transferAllContacts() {
            let sourceRef = this.sourceTenantRef.child('contacts')
            console.log('ref is ' + sourceRef.toString())
            sourceRef.once('value', snap => {
                snap.forEach(itemSnap => {
                    let contactKey = itemSnap.key
                    let contact = itemSnap.val()
                    this.log('Transferring contact: ' + ContactHelpers.fullName(contact) + ' - ' + contactKey)
                    this.copyContactToTenant(contactKey, this.destinationTenant)
                })
            })
        },
 
        transferTasksForUser() {
            let sourceRef = this.sourceTenantRef.child('tasks')
            let listTasksRef = sourceRef.orderByChild('assigned/uid').equalTo(this.user.key)
            let destRef = this.destinationTenantRef.child('tasks')
            console.log('ref is ' + listTasksRef.toString())
    
            listTasksRef.once('value', snap => {
                console.log(snap.val())
                snap.forEach(itemSnap => {
                
                    let taskKey = itemSnap.key
                    let task = itemSnap.val()
                    this.log('Transferring task: ' + task.title + ' - ' + taskKey)
                    this.copyFirebaseData(sourceRef.child(taskKey), destRef, this.move, true ).then(result => {
                        this.log('Done...')
                    })
                })
            })
        },

        copyContactToTenant(contactKey, tenant) {
            let sourceContactRef = this.sourceTenantRef.child('contacts').child(contactKey)
            let destContactRef = DataHelpers.getRootRef().child('tenants').child(tenant).child('contacts')
            
            this.copyFirebaseData(sourceContactRef, destContactRef, this.move, true).then(result => {
                console.log(result)
                this.log('Copied contact: ' + result.object.firstName)

                let sourceContactTransactionsRef = this.sourceTenantRef.child('contactTransactions').child(contactKey)
                let destContactTransactionsRef = DataHelpers.getRootRef().child('tenants').child(tenant).child('contactTransactions')
                
                this.copyFirebaseData(sourceContactTransactionsRef, destContactTransactionsRef, this.move, true).then(tcResult => {
                    console.log('TC Result', tcResult)
                    let transactionArray = Object.keys(tcResult.object)
                    this.log('Copied ' + transactionArray.length + ' contact-transactions')
                    transactionArray.forEach(transactionKey => {
                        let sourceTransactionRef = this.sourceTenantRef.child('transactions').child(transactionKey)
                        let destTransactionRef = DataHelpers.getRootRef().child('tenants').child(tenant).child('transactions')
                        
                        this.copyFirebaseData(sourceTransactionRef, destTransactionRef, this.move, true).then(tResult => {
                            this.log('Copied transaction: ' + tResult.object.details.description)
                        })
                    })
                }, err => {
                    this.log(err.result + ' in contactTransactions')
                })
            })
        },

        copyFirebaseData(fromRef, toRef, move = false, keepSameKey = false) {
        
            return new Promise( (resolve, reject) => {
                console.log('Preparing copyFirebaseData from: ' + fromRef.toString() + ' to ' + toRef.toString())
                let result = {}
                fromRef.once('value', snap => {
                    let obj = snap.val()
                    
                    if(!obj) {
                        result.result = 'Data not found'
                        reject(result)
                    }
                    let newKey = (keepSameKey ? snap.key : DataHelpers.getKey() )

                    if(!this.simulateWrites)
                        toRef.child(newKey).set(obj)
                    else
                        this.log('Simulating write only...')

                    if(move) {
                        this.deleteFirebaseData(fromRef)

                    }

                    result.sourceRef = fromRef.toString()
                    result.destinationRef = toRef.toString()
                    result.object = obj
                    result.sourceKey = snap.key
                    result.destinationKey = newKey
                    resolve(result)
                })
            })
        },

        deleteFirebaseData(fromRef) {
            this.log('Deleting ' + fromRef.toString())
            if(this.simulateDeletes) {
                this.log('Simulating delete only')
                return
            }
            fromRef.remove()
        }



    },

    created() {
    
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// MaintenanceDialog.vue?9325f606